import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../context/GameContext';
import { NoirBackground, Button } from '../components/GameUI';
import { CheckCircle, Scale } from 'lucide-react';
import { toast } from 'sonner';

const Vote = () => {
  const { players, setPlayers, setGameState, setEliminatedPlayer } = useGame();
  const [sel, setSel] = useState(null);
  const active = players.filter(p => !p.isEliminated);

  const go = () => {
    if (!sel) { toast.error('Select the prime suspect'); return; }
    const e = players.find(p => p.id === sel);
    setPlayers(players.map(p => p.id === sel ? { ...p, isEliminated: true } : { ...p, vote: null }));
    setEliminatedPlayer(e); setGameState('elimination');
  };

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center p-6 pb-32 relative select-none">
      <NoirBackground />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md space-y-5 relative z-10">
        <div>
          <div className="flex items-center gap-2 font-mono text-[#5A5A5A] text-xs uppercase tracking-[0.3em] mb-2">
            <Scale size={14} /> The Verdict
          </div>
          <h1 className="font-typewriter text-5xl text-[#E0DDD5] leading-none">Eliminate</h1>
          <p className="text-[#5A5A5A] text-sm font-mono mt-1">Who is the prime suspect?</p>
          <div className="red-line w-full mt-3" />
        </div>
        <div className="space-y-3">
          {active.map((p, i) => (
            <motion.button key={p.id} data-testid={`eliminate-option-${p.id}`}
              onClick={() => setSel(p.id)}
              initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}
              className={`w-full bg-[#141414] border rounded-lg p-5 flex items-center justify-between transition-colors ${
                sel === p.id ? 'border-[#DC2626] bg-[#DC2626]/5' : 'border-[#222]'
              }`} whileTap={{ scale: 0.98 }}>
              <div className="flex items-center gap-3">
                <div className={`w-7 h-7 rounded-full flex items-center justify-center font-mono text-xs font-bold ${
                  sel === p.id ? 'bg-[#DC2626]/30 text-[#EF4444]' : 'bg-[#1A1A1A] text-[#5A5A5A]'
                }`}>{i + 1}</div>
                <span className="text-[#E0DDD5] font-bold">{p.name}</span>
              </div>
              {sel === p.id && <CheckCircle size={18} className="text-[#EF4444]" />}
            </motion.button>
          ))}
        </div>
      </motion.div>
      <div className="fixed bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#080808] via-[#0A0A0A]/95 to-transparent z-20">
        <div className="max-w-md mx-auto">
          <Button data-testid="confirm-elimination-btn" color="bright" disabled={!sel} onClick={go}>
            Eliminate Suspect
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Vote;
